<template>
  <div v-if="!loading">
    <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">
      Attachments
      <template v-if="editable">
        <button
          class="inline hover:underline text-blue-600 focus:outline-none"
          @click="toggleAddAttachmentTabbedFormVisible"
        >
          add
        </button>
      </template>
    </h5>

    <div v-if="addAttachmentTabbedFormVisible" class="shadow-md rounded mb-4">
      <div class="shadow-xs rounded p-4 bg-white">
        <AddAttachmentTabbedForm
          :contact-request-id="contactRequest.id"
          @upload:completed="toggleAddAttachmentTabbedFormVisible"
          @created="toggleAddAttachmentTabbedFormVisible"
        />
      </div>
    </div>

    <div v-else class="mt-2 space-y-2">
      <ul class="grid gap-4">
        <li v-for="attachment in attachments" :key="attachment.id">
          <MediumAttachment
            v-bind="attachment"
            :editable="editable"
            :contact-request-id="contactRequest.id"
          />
        </li>
      </ul>

      <div v-if="attachments.length === 0" class="px-4 py-3 text-sm border border-dashed rounded">
        There are no Attachments.
      </div>
    </div>
  </div>
</template>

<script>
import AddAttachmentTabbedForm from './attachments/AddAttachmentTabbedForm.vue';
import MediumAttachment from './attachments/MediumAttachment.vue';

export default {
  components: {
    AddAttachmentTabbedForm,
    MediumAttachment,
  },
  props: {
    editable: Boolean,
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      addAttachmentTabbedFormVisible: false,
    };
  },
  computed: {
    attachments() {
      return this.$store.getters['ui/contactRequestAttachments/itemsByParent'](
        this.contactRequest.id
      );
    },
  },
  created() {
    this.fetchAttachments();
  },
  destroyed() {
    this.$store.dispatch('ui/contactRequestAttachments/clearByParent', {
      parentId: this.contactRequest.id,
    });
  },

  methods: {
    async fetchAttachments() {
      try {
        this.loading = true;

        await this.$store.dispatch('ui/contactRequestAttachments/load', {
          id: this.contactRequest.id,
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    toggleAddAttachmentTabbedFormVisible() {
      this.addAttachmentTabbedFormVisible = !this.addAttachmentTabbedFormVisible;
      this.fetchAttachments();
    },
  },
};
</script>
